import React, {useState, useEffect, useContext} from 'react'
import ReactDOM from 'react-dom/client'
import AppWrapper from "./components/AppWrapper";

const App = () => {
  let intervalId
  intervalId = setInterval(() => {
    console.log('Waking up... checking if window.app is defined')
    if (window['app'] !== undefined) {
      console.log('yes')
      clearInterval(intervalId)
    } else {
      console.log('no')
    }
  }, 1000)

  if(app.ins.length === 0) {
    return 'Loading...'
  }

  console.log(`%c

 █████   ██████  ███████ ███    ██ ████████      ██████  ██    ██  ██████  ████████ ███████     ██ ███    ██  ██████ 
██   ██ ██       ██      ████   ██    ██        ██    ██ ██    ██ ██    ██    ██    ██          ██ ████   ██ ██      
███████ ██   ███ █████   ██ ██  ██    ██        ██    ██ ██    ██ ██    ██    ██    █████       ██ ██ ██  ██ ██      
██   ██ ██    ██ ██      ██  ██ ██    ██        ██ ▄▄ ██ ██    ██ ██    ██    ██    ██          ██ ██  ██ ██ ██      
██   ██  ██████  ███████ ██   ████    ██         ██████   ██████   ██████     ██    ███████     ██ ██   ████  ██████ 
                                                    ▀▀                                                               

`, `font-family: monospace`);

  console.log(``)

  return (
      <AppWrapper app={window['app']}></AppWrapper>
  )
}

export default App
